export const GROUP_1 = [
  'belebey',
  'beloretsk',
  'eysk',
  'zheleznogorsk',
  'ishim',
  'ishimbay',
  'katavivan',
  'krymsk',
  'meleuz',
  'mtsensk',
  'michurinsk',
  'neftekamsk',
  'novouralsk',
  'okt',
  'pervouralsk',
  'rodniki',
  'salavat',
  'slavyansk',
  'tmz',
  'uhta',
]

export const GROUP_2 = [
  'elektrostal',
  'chita',
  'cherkessk',
  'chel',
  'feodosia',
  'ufa',
  'ulyanovsk',
  '72',
  'tomsk',
  'tlt',
  'temryuk',
  'tambov',
  'tavda',
  'syzran',
  'str',
  'smolensk',
  'simferopol',
  'saratov',
  'samara',
  'rzn',
  'rybinsk',
  'don',
  'rzhev',
  'penza',
  'orel',
  'oren',
  'obninsk',
  'nvrsk',
  'nmosk',
  'nvkb',
  'nf',
  'michurinsk',
  'mih',
  'magnitka',
  'lipetsk',
  'kursk',
  'krasnodar',
  'kovrov',
  'kirov',
  'kineshma',
  'kimry',
  'kaluga',
  'kaliningrad',
  'iglino',
  'zubovo',
  'zarechny',
  'evpatoria',
  'dubna',
  'gubkin',
  'vladimir',
  'vichuga',
  'vn',
  'bryansk',
  'belgorod',
]

export const GROUP_3 = [
  'yar',
  'uu',
  'sykt',
  'surgut',
  'oskol',
  'sochi',
  'sevastopol',
  'reutov',
  'podolsk',
  'omsk',
  'kerch',
  'kazan',
  'irkutsk',
  'dzhankoy',
  'vl',
]

export const GROUP_3_OLD = [
  'schekino',
  'shuya',
  '72',
  'tula',
  'tver',
  'oskol',
  'dubna',
  'vrn',
  'bryansk',
]

export const GROUP_4_OLD = [
  'himki',
  'khanty',
  'severomorsk',
  'svb',
  'murmansk',
  'msk',
  'korolev',
  'ivanovo',
  'zeya',
  'amur',
  'belogorsk',
]

export const StoryGroups = {
  '1_category': GROUP_1,
  '2_category': GROUP_2,
  '3_category': GROUP_3,
  '3_category_old': GROUP_3,
  '4_category_old': GROUP_4_OLD,
}

export const GROUP_RUSSIA = {
  value: 'Россия',
  key: 'RUS_cities',
}

export const USER_STATUS_TAGS = {
  isAuth: 'is_auth', // авторизован
  oneOrder: '1_order', // помечен на беке как новый клиент, имеет один заказ
  old: 'old', // помечен на беке как постоянный клиент, имеет больше одного заказа
  empty: '0_order', // авторизован, orders count = 0
}

export const USER_PLACEHOLDERS = {
  username: 'username',
  bonusCount: 'bonus_count',
  ordersCount: 'orders_count',
  usedBonusesCount: 'used_bonuses_count',
}
